import { iconsSet as icons } from "../../../assets/icons/icons";
export default {
  hero: {
    img: {
      url: "https://tailwindui.com/img/component-images/top-nav-with-multi-column-layout-screenshot.jpg",
      alt: "Nome da extensão",
    },
    title: "Adicione inteligência aos seus trades",

    // String ou array de strings
    text: "Estratégias desenvolvidas 100% por um software de Inteligência Artificial, que monta os modelos, e faz ajustes em tempo real nas estratégias, sempre buscando a melhor adaptação à volatilidade atual do mercado.",
    testimonial: {
      text: "Nossas estratégias contam com o que existe de melhor no mundo da Inteligência Artificial, e evoluem constantemente, sem nenhuma intervenção humana. É a realidade do Trade Inteligente chegando ao mercado.",
      author: {
        name: "Fulano Oliveira, CEO Placeholder Algoritmos",
        picture: "",
      },
    },
  },
  stats: {
    title: "Números ao longo desses 7 anos de experiência",
    subtitle:
      "A Placeholder é uma das empresas pioneiras no desenvolvimento de algotirmos para negociações automatizadas.",
    data: [
      {
        value: "+30k",
        description: "Clientes",
      },
      {
        value: "+10M",
        description: "Contratos negociados",
      },
      {
        value: "+155Bi",
        description: "Volume financeiro",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Placeholder?",
    subtitle: "Veja quais as principais vantagens dos robôs da Placeholder.",
    data: [
      {
        icon: icons.lightning,
        title: "Velocidade",
        description:
          "Os nossos algoritmos conseguem realizar milhares de cáculos por segundo e tomam decisões muito mais rápido do que qualquer ser humano.",
      },
      {
        icon: icons.clock,
        title: "Ganhe tempo",
        description:
          "Você não precisa ficar na frente no computador para realizar suas operações. Escolha suas estratégias e deixe que a plataforma opere por você.",
      },
      {
        icon: icons.favorite,
        title: "Sem emocional",
        description:
          "Muitas vezes agimos de maneira irracional e impulsiva em nossos investimentos. Com as estratégias automatizadas você não terá esse problema!",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a Placeholder IA.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Placeholder",
    col1: [
      'Somos Traders! E isso faz toda a diferença. Nosso trabalho com algoritmos vem desde 2012, quando, sem ferramentas adequadas no mercado brasileiro, começamos a desenhar estratégias e monitorar o mercado através de planilhas em Excel. É evidente que as estratégias eram simples, e os problemas, enormes. Só podíamos trabalhar com tempos gráficos maiores, pois não tínhamos os dados em tempo real. Os indicadores tinham que ser todos construídos "na mão". Acabamos entrando no mundo da programação por necessidade, pois precisávamos construir macros no Excel que gravassem os dados do mercado via link DDE (recurso que importa para o Excel cotações em tempo real), e, com isso, operar tempos gráficos menores. Posteriormente, encontramos um sistema que permitia o envio de ordens diretamente pelo Excel, o que, para nós, já era uma grande evolução. Além disso, passamos a ter também o histórico que tanto precisávamos, mesmo que cheio de falhas. Esse sistema, apesar dos erros recorrentes (que nos levaram, futuramente, a abandoná-lo) permitiu que montássemos nosso primeiro robô 100% automatizado, com o qual tivemos excelentes resultados. As já citadas falhas,porém, nos levaram a decisão de desligar o sistema. Naquele momento, final de 2013, as perspectivas eram as piores possíveis para o mercado de robôs investidores.',
      "No início de 2014, porém, tudo mudou. Ficamos sabendo que a XP Investimentos traria para o Brasil o MetaTrader 5, o sistema mais utilizado no mundo para automatização no mercado financeiro. Iniciamos imediatamente os estudos, e, em maio, no mesmo mês em que o sistema foi lançado, já tínhamos robôs operando no sistema.",
    ],
    col2: [
      'Com o conhecimento e a experiência que já tínhamos, evoluímos rapidamente, o que acabou levando a um convite por parte da XP para que o sócio fundador da Placeholder, Fabiano Oliveira, assumisse o projeto MetaTrader no Brasil. Durante esse período, merecem destaque a criação e desenvolvimento da comunidade MetaTrader 5 - Experiências, que hoje conta com milhares de usuários e desenvolvedores, e a produção da "Boleta Turbo", que passou a ser distribuída com o próprio MetaTrader da XP, e é o robô mais utilizado do Brasil, sendo utilizado por centenas de pessoas, e negociando milhares de contratos por dia.',
      'Em Julho de 2015, Fabiano Oliveira retornou a Placeholder, onde continuou a parceria com a XP Investimentos, buscando o desenvolvimento do mercado de algoritmos no Brasil. Os robôs Placeholder se tornaram, então, sinônimo de estabilidade e qualidade, sendo utilizados por milhares de usuários. Nosso sistema de conexão remota revolucionou o mercado, permitindo um ganho de escala nunca visto nessa área, e se tornando a base da grande campanha que lançamos por robôs "a preço justo", em dezembro/2015. Somos a maior plataforma de robôs do país, e acreditamos que a automatização é a maior revolução no mercado financeiro desde o Home Broker. A Placeholder tem orgulho de sua história se confundir com a própria história da automatização no mercado de varejo do Brasil. Temos a certeza de que, mais do que apenas percebendo, estamos PROMOVENDO esta mudança.',
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Placeholder IA",
  },
  strategies: {
    title: "Placeholder IA",
    heading: "Tenha acesso às melhores estratégias de day trade",
    subtitle: "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
};
